/**
 * Manifiesto frontend — Gestión Despacho (Fase 1 visual mock).
 * Sin backend; sincronizar con catálogo en Fase 2.
 */
export const MODULO_DESPACHO_ID = "gestion_despacho";

export const DESPACHO_CONTEXT_LABEL = "Gestión Despacho";

export const MODULO_DESPACHO_CARD = {
  id: MODULO_DESPACHO_ID,
  title: DESPACHO_CONTEXT_LABEL,
  description: "Operación avanzada: clientes operativos, tareas, asignaciones y atención a clientes (WhatsApp Business).",
  bullets: [
    "Clientes operativos del despacho (distintos de contribuyentes fiscales del Visor SAT)",
    "Tareas, pendientes por auxiliar y calendario operativo",
    "Asignaciones auxiliar ↔ cliente y control de carga",
    "Atención a clientes tipo WhatsApp Business (bandeja compartida)",
    "Tablero operativo: pendientes por empresa y seguimiento del equipo",
  ],
  entryPath: "/despacho/inicio",
  path: "/despacho/inicio",
  route: "/despacho/inicio",
};

/** Pestañas principales del sidebar / hub. */
export const DESPACHO_TAB_CONFIG = [
  {
    id: "dashboard",
    path: "/despacho/inicio",
    label: "Inicio del módulo",
    description: "Tarjetas de acceso y 4 KPIs; el detalle de pendientes está en Tablero operativo.",
    iconKey: "panel",
  },
  {
    id: "clientes",
    path: "/despacho/clientes",
    label: "Asignacion de Empresas a Auxiliares",
    description:
      "Asigne qué auxiliar atiende cada empresa del catálogo fiscal (Clientes). Los WhatsApp se capturan en Clientes.",
    iconKey: "clients",
  },
  {
    id: "tareas",
    path: "/despacho/tareas",
    label: "Tareas Operativas",
    description:
      "Seguimiento de obligaciones, tareas del equipo y pendientes por auxiliar.",
    iconKey: "listchecks",
  },
  {
    id: "calendario",
    path: "/despacho/calendario",
    label: "Calendario y Recordatorios",
    description:
      "Reglas de vencimiento, plantillas e interruptores de avisos. La bandeja de conversación está en Atención a clientes.",
    iconKey: "calendar",
  },
  {
    id: "honorarios",
    path: "/despacho/honorarios",
    label: "Control de honorarios y Contratos",
    description:
      "Cobranza de honorarios, convenios y comprobantes ligados a CFDI.",
    iconKey: "reports",
  },
  {
    id: "reportes",
    path: "/despacho/reportes",
    label: "Tablero operativo",
    description:
      "Pendientes por empresa: vencidos, esta semana, tareas y clientes incompletos (CFS / obligaciones).",
    iconKey: "reports",
  },
  {
    id: "configuracion",
    path: "/despacho/configuracion-modulo",
    label: "Parámetros del módulo",
    description: "Roles, invitación de auxiliares, plantillas de tareas e integraciones opcionales (mock Fase 1).",
    iconKey: "settings",
    hubOnlyNav: false,
  },
];

export function getDespachoFeatureCards() {
  return DESPACHO_TAB_CONFIG.map((tab) => ({
    path: tab.path,
    label: tab.label,
    description: tab.description,
    iconKey: tab.iconKey,
  }));
}
